const subscriptionProcessingStatuses = {
  new: 'NEW',
  progress: 'IN_PROGRESS',
}

export default subscriptionProcessingStatuses
